// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import store from '../../redux/store';
import _ from 'lodash';
import { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

function withAuthHeader(axios: AxiosInstance): AxiosInstance {
  axios.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    const state = store.getState();
    const authToken = _.get(state, 'auth.accessToken');
    if (!authToken) return config;
    else {
      config.headers['Authorization'] = `Bearer ${authToken}`;
      return config;
    }
  });
  return axios;
}

export default withAuthHeader;
